const Title = ({ title = null, subtitle = null }) => (
  <div className="mb-4" data-cy="headerBox">
    <div className="text-4xl uppercase font-bold">{title}</div>
    {subtitle !== null ? <div>{subtitle}</div> : null}
  </div>
);

export default Title;
